export default "__VITE_ASSET__DfBnEZ_a__";